import { schedulerSwitchOptions, toggleScheduler } from './jobDetailsFormModel'
import LabeledSwitch from '../common/LabeledSwitch'

type Props = {
  options: { label: string, value: string }[]
  value?: string[]
  onChange?: (value: string[]) => void
}

const SchedulerSwitches = ({ options, value, onChange }: Props) => {
  const selected = value ?? []
  return <div role="group" aria-label="Notify Schedulers"
    style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '8px 16px' }}>
    {schedulerSwitchOptions(options, selected).map(option => <LabeledSwitch key={option.value} size="small" label={option.label} aria-label={option.label}
      value={selected.includes(option.value)}
      onChange={notify => onChange?.(toggleScheduler(selected, option.value, notify))} />)}
  </div>
}

export default SchedulerSwitches
